import baguetteBox from 'baguettebox.js';

baguetteBox.run('.comment-images');

